export default "__VITE_ASSET__CSb53eA5__"